import * as languagesActions from "./actions";
import languagesEpic from "./epic";
import type { ILanguageData } from "./models";
import languagesReducer from "./reducer";
import type { LanguagesAction } from "./reducer";

export type { ILanguageData, LanguagesAction };
export { languagesEpic, languagesActions };
export default languagesReducer;
